import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2 py-0.5 text-[11.5px] font-semibold leading-4 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-foreground/[0.07] text-foreground',
        secondary: 'border-transparent bg-foreground/[0.06] text-muted-foreground',
        destructive: 'border-transparent bg-destructive/[0.12] text-destructive',
        success: 'border-transparent bg-success/[0.12] text-success',
        warning: 'border-transparent bg-warning/[0.14] text-warning',
        outline: 'rounded-[5px] border-border bg-card font-mono font-normal text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
